import { Col } from '../grid';
export default Col;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/col/index.js
// module id = 282
// module chunks = 0